import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api} from '../../actions/_request';

//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

// styling
import './style.css';

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';

import _ from 'underscore';



//icons
import FAfloppyO from 'react-icons/lib/fa/floppy-o';
import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import Fasearch from 'react-icons/lib/fa/search';
const {PropTypes} = React;

const CustomTooltip  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}

      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : $${new Intl.NumberFormat().format(item.value)}`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});

const CustomTooltip2  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : ${item.value} %`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});
const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

const anos = [
	{label : '2018' , value :2018},
	{label : '2019', value :2019},
	{label : '2020', value :2020},
];

const reportes = [
	{label : 'Participaciones Contpaq' , value: 9},
	{label : 'Produccion individual' , value : 1},
	{label : 'Produccion por departamento', value : 2},
	{label : 'Reporte de garantias', value : 3},
	{label : 'Reporte de cumplimiento de citas' , value: 4},
	{label : 'Reporte de Comisiones' , value: 5},
	{label : 'Ventas Especiales' , value: 6},
	{label : 'Corte del dia' , value: 7},
	{label : 'Ticket sin PV' , value: 8},

];

const departamentos = [
	{label: 'Ventas', value: 1},
	{label: 'Contpaq', value: 2},
	{label: 'Remanufacturado', value: 3},
	{label: 'Tecnico', value: 4},
	{label: 'Instalaciones', value: 5}
];

const tipos = [
    {label: 'Todos', value: 0},
	{label: 'Tienda', value: 1},
	{label: 'Sitio', value: 2},
	{label: 'Remoto', value: 3},
	{label: 'Venta', value: 4}
];


class Reportes extends React.Component
{
	constructor(props){
		super(props)

		var fecha = new Date( moment().format('Y-MM-DD')+'T12:00:00Z');
		

		// var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		

  //       var firstDay = new Date('Y-m-d',y, m, 1);
  //       var lastDay = new Date(y, m + 1, 0);
  //       var dia=lastDay.getDate();
		// m++;
		// if(m==13)m=1;
// moment(y, m, 1)).format('Y-MM-DD')
		this.state = {
			reporte : {
				reporte_id : 2,
				// fecha_1 :moment(`${y}-${m}-1`).format('Y-MM-DD') ,
				// fecha_2 : moment(`${y}-${m}-${dia}`).format('Y-MM-DD') ,
				fecha_1 :'' ,
				fecha_2 : '' ,
				filtro_2 : '',
				user_id : '',
				tipo_id:0,
				mes:(fecha.getMonth()+1),
			    ano:2018,

			},
			data:[],
			usuarios : [],
			urlreporte:"",
			urlreporte2:"",
			routeEntrega : "",
			routesinpv:'',
			reporte_contpaq:'',
			cliente : null,
			inicio:0,
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.search = this.search.bind(this);
		this.filter = this.filter.bind(this);

		

	}

	componentDidMount(){
        let self = this;

        api().get('/fecha_inicio_final')
        .then(function(response)
        {

        	self.props.cambio_fechas(response.data.inicio,response.data.final);

        	self.setState({
            reporte : {
            	reporte_id : 2,
				fecha_1 : response.data.inicio,
				fecha_2 : response.data.final ,
			},
        });
                api().get(`/reporte/produccion/${response.data.inicio}/${response.data.final}`)
		        .then(function(response)
		        {
		            self.setState({
		                data : response.data,
		                
		            });
		            
		        });
         
           
        });

		
	}

	 componentWillReceiveProps(nextProps)
    {
        let {inicio, final} = nextProps;
      
        let self = this;

        this.setState({
            reporte : {
            	reporte_id : 2,
				fecha_1 :inicio ,
				fecha_2 : final ,
			},
        });
    }

	handleInputChange(event) {

		if(event === null) return;

		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		console.log(name)
		console.log(value)

		this.setState({
			reporte: {
				...this.state.reporte,
				[name]: value
			},

                urlreporte : "",
                urlreporte2 : "",
                routeEntrega : '',
                routesinpv:'',
                reporte_contpaq:'',
           
		});
		let reporte =this.state.reporte;
		if('fecha_1'==name){
			this.props.cambio_fechas(value,reporte.fecha_2);
		}else if('fecha_2'==name){
			this.props.cambio_fechas(reporte.fecha_1,value);
		}

		

	}

	handleSelectChange(select, name) {

		const value = select === null ? null : select.value;

		this.setState({
			reporte: {
				...this.state.reporte,
				[name]: value
			},
			urlreporte : "",
            urlreporte2 : "",
            routeEntrega : '',
            routesinpv:'',
            reporte_contpaq:'',
		});

		if(name === 'user_id'){
			this.cliente = select;
		}
	}

	search(){

		let {reporte } = this.state;
        console.log("Reporte aqui imprimo----->",reporte);
		let route ="/reporte"

		let self = this;
		switch(reporte.reporte_id){
			case 1: 
				route += "/produccionindividual/"+ reporte.user_id + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				break;
			case 2: 
				route += "/produccion/"+reporte.fecha_1 + "/" + reporte.fecha_2;
				break;
			case 3: 
				route += "/garantia/" + reporte.fecha_1 + "/" + reporte.fecha_2;

				break;
			case 4: 
				route +=  "/cumplimiento/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				break;
			case 5: 
				route += "/comisiones/"+ reporte.user_id + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				 self.setState({
                urlreporte : route
            });
				 route ="/reporte";


				break;
			case 6: 
				var user=reporte.user_id;
				if(user === '' || user === null)
				{
					user=0;
				}
				route += "/ventas_especiales/"+ user + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				 self.setState({
                	urlreporte2 : route
            	});

				 route ="/reporte";
				


				break;
			case 7:
				route += "/entregas_diarias/"+reporte.fecha_1;
				self.setState({
                	routeEntrega : route
            	});
				break;
				case 8:
				route += "/tickets_sinpv/"+reporte.tipo_id + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				self.setState({
                	routesinpv : route
            	});
				break;
				case 9:
				var fecha = new Date(reporte.fecha_1+'T12:00:00Z');
				// console.log('Fecha state--->',reporte.fecha_1);
				// console.log('Fecha--->',fecha);
				//  console.log('mes--->',fecha.getMonth()+1);
				//  console.log('mes--->',fecha.getFullYear());
				
				route += "/contpaq/"+(reporte.mes)+"/"+reporte.ano;
				self.setState({
                	reporte_contpaq : route
            	});
				break;

		}
		
		if(route !== "/reporte" && reporte.reporte_id !== 7){
		api().get(route)
        .then(function(response)
        {
            self.setState({
                data : response.data,
                
            });
            
        });
    }


	}

	filter(evt){

		let {reporte} = this.state;
		let route ="/reporte"
		

		let self = this;
		switch(reporte.reporte_id){
			case 1: 

				break;
			case 2: 
			if(evt.estado == 'departamento'){
					// route += "/produccion/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				}else{
					route += "/produccion_departamento/"+evt.id + '/' + reporte.fecha_1 + "/" + reporte.fecha_2;
				}

				break;
			case 3: 
				if(evt.estado == 'individual'){
					route += "/garantia/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				}else{
					route += "/garantiadepartamento/"+evt.id + '/' + reporte.fecha_1 + "/" + reporte.fecha_2;
				}
				break;
			case 4: 


				break;
		}

		if(route !== "/reporte"){

		api().get(route)
        .then(function(response)
        {
            self.setState({
                data : response.data
            });
           
        });
    	}

	}
	formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}


	render(){
		console.log('data-->',this.state);

		let {reporte,inicio} = this.state;




		let show = false;
		let etiqueta_filtro_2 = '';
		let opciones_filtro2 = '';
		let title = "";
		let key = '';
		let grafica = false;
		let PDF =false;
		let etiqueta="Fecha de Inicio:";
		if(reporte.reporte_id === 7){
			etiqueta = "Fecha:";
		}
		switch(reporte.reporte_id){
			case 1:
				show = true;
				title = "Produccion individual ";
				key ="total";
				grafica = true;
				break;
			case 2:
				title = "Utilidad por departamento";
				show = true;
				key ="total";
				grafica = true;
				break;
			case 3: 
				title = "Garantias";
				key="Garantias";
				grafica = true;
				break;
			case 4: 
				title = 'cumplimiento de citas';
				key = "Total";
				grafica = true;
				break;
				case 5: 
				PDF=true;
				
				grafica = false;
				break;

			default:
				show = false;
		}

		 
	     
	   

		return(
			<div className="view">
				<div className="view-header">
					<header className="title text-white">
						<h1 className="h4 text-uppercase">Reporte por Departamentos</h1>

						
					</header>
				</div>
				<div className="view-content view-components">
					<Card className="mb-4">
						<CardBlock>

							<div className="row mb-3">
								
							  
								
								<div className="col-sm-4 col-md-2 col-12">
									<div className="form-group">
										<label className>{etiqueta}</label>
										<input
											type="date" 
											className="form-control"
											name="fecha_1"
											value={reporte.fecha_1 || ''}
											onChange={this.handleInputChange}
										/>
									</div>
								</div>
							    
							   
								
									<div className="col-sm-4 col-md-2 col-12">
										<div className="form-group">
											<label className>Fecha Final:</label>
											<input
												type="date" 
												className="form-control"
												name="fecha_2"
												value={reporte.fecha_2 || ''}
												onChange={this.handleInputChange}
											/>
										</div>
									</div>
								
								 
								<div className="col-sm-4 col-md-2 text-right">
									<label><br/></label><br/>
									<Button color='success' onClick={this.search}> <Fasearch/> </Button>
								</div>
							</div>
							
							
							
						</CardBlock>
					</Card>
					
					{
						grafica && 
						
                    <CardBlock>
                        <CardTitle className="text-uppercase h6">{title}  <Button color="success" className="mx-4" onClick={this.search} >
                                Regresar
                            </Button></CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
                                  
     								{
                                    (Object.keys(this.state.data).length === 0 ||reporte.reporte_id === 4||reporte.reporte_id === 3)?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip/>}/>


                                  }

                                  <Legend />
                                  <Bar dataKey={key} fill='#406CBF' onClick={this.filter} minPointSize={1} />
                                  {
                                  	reporte.reporte_id === 1 && 
                                  	<Bar dataKey="meta" fill='green'  minPointSize={1} />
                                  }
                                  {
                                  	reporte.reporte_id === 4 && 
                                  	<Bar dataKey="Cumplidas" fill='green' onClick={this.filter} minPointSize={1} />
                                  }
                                  {
                                  	reporte.reporte_id === 4 && 
                                  	<Bar dataKey="Retardos" fill='orange' onClick={this.filter} minPointSize={1} />
                                  }
                                  {
                                  	reporte.reporte_id === 4 && 
                                  	<Bar dataKey="Retardos Criticos" fill='red' onClick={this.filter} minPointSize={1} />
                                  }
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                    
                }

                {
							reporte.reporte_id === 2 && 
						
                    <CardBlock>
                        <CardTitle className="text-uppercase h6">Produccion por Departamento  </CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
                                  
     								{
                                    (Object.keys(this.state.data).length === 0 ||reporte.reporte_id === 4||reporte.reporte_id === 3)?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip/>}/>


                                  }

                                  <Legend />
                                  <Bar dataKey='Total Ventas' fill='#406CBF' onClick={this.filter} minPointSize={1} />
                                  
                                  
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                    
                }


                
				</div>	
			</div>
			)
	}
}

export default Reportes;


// WEBPACK FOOTER //
// ./src/views/dashboard/reporte_departamento.js